import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class ProductLostSubReasonService {

  constructor(private ws: PostmethodService) { }

  productLostSubReasonCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "productLostSubReasonsMaster");
  }

  getProductLostReasons(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "productLostReasonsMaster");
  }
}
